import SiteMapHeaderRow from './site-map-rows/SiteMapHeaderRow';
import SiteMapMenuGroupRow from './site-map-rows/SiteMapMenuGroupRow';
import SiteMapHeading from './site-map-heading/SiteMapHeading';
import {
	MenuGroup,
	MenuItem,
} from '../../../../components/blackrock/advisor-center/_types/navigation';
import SiteMapWrapper from './SiteMapWrapper';

import './SiteMap.scss';

export interface SiteMapData {
	name: string;
	menuGroups: MenuGroup[];
	active?: boolean;
}

export type SiteMapProps = {
	myHubDataInput?: MenuItem;
	myHubFallback: string;
	siteMapDataInput: SiteMapData[];
	exploreMoreLabel?: string;
};

/**
 * SiteMap Component
 * Main component for SiteMap (Secondary Navigation)
 */
const SiteMap: React.FC<SiteMapProps> = ({
	myHubDataInput,
	myHubFallback = 'Explore more',
	siteMapDataInput,
	exploreMoreLabel = 'Keep exploring',
}) => {
	return (
		<SiteMapWrapper exploreMoreLabel={exploreMoreLabel}>
			<SiteMapHeading
				myHubDataInput={myHubDataInput}
				myHubFallback={myHubFallback}
			/>
			{siteMapDataInput.length > 6
				? renderTwoSiteMapRow(siteMapDataInput)
				: renderSiteMapRow(siteMapDataInput, siteMapDataInput.length)}
		</SiteMapWrapper>
	);
};

export default SiteMap;

const renderTwoSiteMapRow = (siteMapRowData: SiteMapData[]) => {
	return (
		<>
			{renderSiteMapRow(siteMapRowData.slice(0, 4), 4)}
			{renderSiteMapRow(siteMapRowData.slice(4), 4, 4)}
		</>
	);
};

const renderSiteMapRow = (
	siteMapRowData: SiteMapData[],
	numOfCols: number,
	startIndex = 0
) => {
	return (
		<>
			<SiteMapHeaderRow
				siteMapRowData={siteMapRowData}
				numOfCols={numOfCols}
				startIndex={startIndex}
			/>
			<SiteMapMenuGroupRow
				siteMapRowData={siteMapRowData}
				numOfCols={numOfCols}
				startIndex={startIndex}
			/>
		</>
	);
};
